import React from 'react'
import { List } from 'antd';
import { useSelector } from 'react-redux';

import styles from './GuestScreen5.module.css';
import { SubmitButton, TextComponent } from '../../../../components';

const GuestScreen5 = ({setCurrentStep}) => {
    const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);

    return (
        <div className={styles.mainCont}>
            <TextComponent text={"Get Informed"} textClass={styles.heading}/>
            <List
            dataSource={WeddingWeb?.get_informed?.length > 0 ? WeddingWeb?.get_informed : []}
            className={styles.list}
            renderItem={(item,index)=>{
                return (
                    <div className={styles.listItem} key={index}>
                        <TextComponent text={item?.question} textClass={styles.question}/>
                        <TextComponent text={item?.answer} textClass={styles.answer}/>
                    </div>
                )
            }}
            />
              <div className={styles.submitBtn}>
            <SubmitButton
              btnClass={styles.nextBtn2}
              title={"Next"}
              onClick={()=> setCurrentStep((prev) => prev + 1)
              }
            />
          </div>
        </div>
    )
}

export default GuestScreen5
